// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DynamicFormShell-module__logoContainer__X9ego {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: var(--mantine-spacing-md) 0;
}

.DynamicFormShell-module__logo__xYdDK {
  max-height: 80px;
  max-width: 200px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.DynamicFormShell-module__validationBox__aOZNP {
  border: 1px solid var(--mantine-color-red-6);
  border-radius: var(--mantine-radius-md);
  background-color: var(--mantine-color-gray-1);
  padding: var(--mantine-spacing-md);
}

.DynamicFormShell-module__validationIcon__wTMSV {
  color: var(--mantine-color-red-6);
  flex-shrink: 0;
}

.DynamicFormShell-module__validationTitle__jhhjt {
  color: var(--mantine-color-red-6);
  font-size: var(--mantine-font-size-sm);
}

.DynamicFormShell-module__validationTag__KnDdl {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: var(--mantine-radius-xl);
  border: 1px solid var(--mantine-color-red-6);
  background-color: var(--mantine-color-red-0);
  color: var(--mantine-color-red-8);
  font-size: var(--mantine-font-size-xs);
  font-weight: 500;
  line-height: 1.6;
}

[data-mantine-color-scheme='dark'] .DynamicFormShell-module__validationBox__aOZNP {
  background-color: var(--mantine-color-dark-7);
  border-color: var(--mantine-color-red-7);
}

[data-mantine-color-scheme='dark'] .DynamicFormShell-module__validationTag__KnDdl {
  background-color: color-mix(in srgb, var(--mantine-color-red-9) 20%, transparent);
  border-color: var(--mantine-color-red-7);
  color: var(--mantine-color-red-3);
}
`, "",{"version":3,"sources":["webpack://./src/features/application-form/sections/DynamicFormShell.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,4CAA4C;EAC5C,4CAA4C;EAC5C,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,iFAAiF;EACjF,wCAAwC;EACxC,iCAAiC;AACnC","sourcesContent":[".logoContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: var(--mantine-spacing-md) 0;\n}\n\n.logo {\n  max-height: 80px;\n  max-width: 200px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.validationBox {\n  border: 1px solid var(--mantine-color-red-6);\n  border-radius: var(--mantine-radius-md);\n  background-color: var(--mantine-color-gray-1);\n  padding: var(--mantine-spacing-md);\n}\n\n.validationIcon {\n  color: var(--mantine-color-red-6);\n  flex-shrink: 0;\n}\n\n.validationTitle {\n  color: var(--mantine-color-red-6);\n  font-size: var(--mantine-font-size-sm);\n}\n\n.validationTag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: var(--mantine-radius-xl);\n  border: 1px solid var(--mantine-color-red-6);\n  background-color: var(--mantine-color-red-0);\n  color: var(--mantine-color-red-8);\n  font-size: var(--mantine-font-size-xs);\n  font-weight: 500;\n  line-height: 1.6;\n}\n\n:global([data-mantine-color-scheme='dark']) .validationBox {\n  background-color: var(--mantine-color-dark-7);\n  border-color: var(--mantine-color-red-7);\n}\n\n:global([data-mantine-color-scheme='dark']) .validationTag {\n  background-color: color-mix(in srgb, var(--mantine-color-red-9) 20%, transparent);\n  border-color: var(--mantine-color-red-7);\n  color: var(--mantine-color-red-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoContainer": `DynamicFormShell-module__logoContainer__X9ego`,
	"logo": `DynamicFormShell-module__logo__xYdDK`,
	"validationBox": `DynamicFormShell-module__validationBox__aOZNP`,
	"validationIcon": `DynamicFormShell-module__validationIcon__wTMSV`,
	"validationTitle": `DynamicFormShell-module__validationTitle__jhhjt`,
	"validationTag": `DynamicFormShell-module__validationTag__KnDdl`
};
module.exports = ___CSS_LOADER_EXPORT___;
